
import Vue from 'vue'
import { Component } from 'vue-property-decorator'

// Style-only comonent

@Component<WhiteCard>({})
export default class WhiteCard extends Vue {}
